import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import style from './Curtains.module.scss';
import { CurtainsAumbreDetails } from "./CurtainsConstant";
import { saveUpdatedPageDetails, saveMetaDataUpdate } from "../../../actions/wizard";
import defaultImage from '../../../assets/default.png';

const CurtainsAumbre = (props: any) => {
  const dispatch = useDispatch();
  const { isDrawingsExporting } = props;
  const pageDetails = useSelector((state: any) => state.wizard.pageDetails);
  const requiredMetaDataUpdate = useSelector((state: any) => state.wizard.requiredMetaDataUpdate);

  const latestStateRef = useRef(requiredMetaDataUpdate);

  const [updatedValues, setUpdatedValues] = useState(pageDetails);

  useEffect(() => {
    setUpdatedValues(pageDetails)
  }, [pageDetails]);

  // Update the meta details while unmounting.
  useEffect(() => {
    return () => {
      updateDetailsInMeta(false);
    }
  }, [])

  // Updating Item details in meta data
  const updateItems = (details: any) => {
    const updatedObj: any = {
      ...updatedValues,
      metaData: {
        ...updatedValues?.metaData,
        [details.id]: details.value
      }
    };
    setUpdatedValues(updatedObj)
    dispatch(saveMetaDataUpdate(updatedObj))
  }

  // Save function to save details in API
  const updateDetailsInMeta = (required: boolean) => {
    if (latestStateRef.current) {
      dispatch(saveUpdatedPageDetails(latestStateRef.current, required));
      dispatch(saveMetaDataUpdate(false))
    }
  }

  // Created a debounce to update the exiting quote details 
  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      updateDetailsInMeta(true);
    }, 4000); // Adjust the delay (in milliseconds) as needed

    latestStateRef.current = requiredMetaDataUpdate;

    return () => {
      clearTimeout(debounceTimer);
    };
  }, [requiredMetaDataUpdate]);

  const panelDetails = updatedValues?.curtainsDetails?.length ? updatedValues?.curtainsDetails : CurtainsAumbreDetails;

  return (
    <section className={style.curtains_room_container}>
      <h2 className="section_heading">{updatedValues?.name}</h2>
      <div className={style.curtains_details_tabs}>
        <div className={style.curtains_work_image_columns}>
          <section style={{ gridTemplateRows: '1fr max-content 1fr' }}>
            <div className={style.left_image_section}>
              <p>Key Plan of the House / <br /> Site Photograph of the Room</p>
            </div>
            <hr />
            <div className={style.left_image_section}>
              {updatedValues?.images?.length ? <img crossOrigin="anonymous" src={updatedValues?.images[0] ? `${updatedValues?.images[0]}?ver=${new Date().getTime()}`: defaultImage} alt="" style={{ maxHeight: updatedValues?.images?.length > 1 ? '170px' : '190px' }} className="image-view" /> : <p>Fabric Image(s)</p>}
            </div>
          </section>
          <section>
            <div>
              <p>Window Elevation with</p>
              <p>a) Overall Window Dimensions (X & Y Axis); </p>
              <p>b) Overall Curtain Dimensions (X+10" & Y+10")</p>
              <span>Designer to denote each panel as (Panel Code A,B, C, D etc.) with Legend Below:</span>
              <p>Panel A: Panel Dimension: Panel Size (Width & Height): Panel Fabric</p>
            </div>
            {
              updatedValues?.curtainsDetails?.some((e: any) => e?.designType) ? (
                <div className={style.right_image_section} style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', borderTop: ' 1px solid #BDC1CA', height: '25%' }}>
                  {updatedValues?.curtainsDetails?.map((e: any, i: number) => (
                    <div style={{ borderRight: '1px solid #BDC1CA' }}>
                      <p style={{ marginTop: '20px' }}>{e?.['wall_orientation_'+i]}</p>
                      <img key={i} src={e?.designType ? `${e?.designType}?ver=${new Date().getTime()}` : defaultImage} alt="" style={{ maxHeight: '160px' }} className="image-view" />
                    </div>
                  ))}
                </div>
              ) : ''
            }
          </section>
        </div>
        <div className={style.curtains_item_container}>
          <h2 className="sub_tab_heading">{updatedValues?.curtainsDetails?.[0]?.heading ? updatedValues?.curtainsDetails?.[0]?.heading : 'Curtains Details'}</h2>
          <div className={style.demolition_item_details_panel}>
            <div className={style.curtains_details_tabs_9_col}>
              <h4>SKU Code</h4>
              <h4>Product Name</h4>
              <h4>Qty | Size (mm)</h4>
              <h4>UOM</h4>
              <h4>Type</h4>
              <h4>Wall Orientation / Window Reference</h4>
              <h4>Window/Door  WidthX Height in Feet</h4>
              <h4>Hardware Details</h4>
              <h4>Finial Details</h4>
            </div>
            <div className={`${style.curtains_items_list} ${style.curtains_details_tabs_9_col}`}>
              {
                panelDetails?.map((e, i) => (
                  <>
                    <p>
                      <div className={style.option_view}>
                        {!isDrawingsExporting ? <input value={updatedValues?.metaData?.[`sku_code_${i}`] || e?.[`sku_code_${i}`] || ''} onChange={(v) => updateItems({ id: `sku_code_${i}`, value: v.target.value })} /> : <span>{updatedValues?.metaData?.[`sku_code_${i}`] || e?.[`sku_code_${i}`] || '-'}</span>}
                      </div>
                    </p>
                    <p>
                      <div className={style.option_view}>
                        {!isDrawingsExporting ? <input value={updatedValues?.metaData?.[`fabric_name_${i}`] || e?.[`fabric_name_${i}`] || ''} onChange={(v) => updateItems({ id: `fabric_name_${i}`, value: v.target.value })} /> : <span>{updatedValues?.metaData?.[`fabric_name_${i}`] || e?.[`fabric_name_${i}`] || '-'}</span>}
                      </div>
                    </p>
                    <p>
                      <div className={style.option_view}>
                        {!isDrawingsExporting ? <input value={updatedValues?.metaData?.[`quantity_${i}`] || e?.[`quantity_${i}`] || ''} onChange={(v) => updateItems({ id: `quantity_${i}`, value: v.target.value })} /> : <span>{updatedValues?.metaData?.[`quantity_${i}`] || e?.[`quantity_${i}`] || '-'}</span>}
                      </div>
                    </p>
                    <p>
                      <div className={style.option_view}>
                        {!isDrawingsExporting ? <input value={updatedValues?.metaData?.[`uom_${i}`] || e?.[`uom_${i}`] || ''} onChange={(v) => updateItems({ id: `uom_${i}`, value: v.target.value })} /> : <span>{updatedValues?.metaData?.[`uom_${i}`] || e?.[`uom_${i}`] || '-'}</span>}
                      </div>
                    </p>
                    <p>
                      <div className={style.option_view}>
                        {!isDrawingsExporting ? <input value={updatedValues?.metaData?.[`type_${i}`] || e?.[`type_${i}`] || ''} onChange={(v) => updateItems({ id: `type_${i}`, value: v.target.value })} /> : <span>{updatedValues?.metaData?.[`type_${i}`] || e?.[`type_${i}`] || '-'}</span>}
                      </div>
                    </p>
                    <p>
                      <div className={style.option_view}>
                        {!isDrawingsExporting ? <input value={updatedValues?.metaData?.[`wall_orientation_${i}`] || e?.[`wall_orientation_${i}`] || ''} onChange={(v) => updateItems({ id: `wall_orientation_${i}`, value: v.target.value })} /> : <span>{updatedValues?.metaData?.[`wall_orientation_${i}`] || e?.[`wall_orientation_${i}`] || '-'}</span>}
                      </div>
                    </p>
                    <p>
                      <div className={style.option_view}>
                        {!isDrawingsExporting ? <input value={updatedValues?.metaData?.[`window_door_height_${i}`] || e?.[`window_door_height_${i}`] || ''} onChange={(v) => updateItems({ id: `window_door_height_${i}`, value: v.target.value })} /> : <span>{updatedValues?.metaData?.[`window_door_height_${i}`] || e?.[`window_door_height_${i}`] || '-'}</span>}
                      </div>
                    </p>
                    <p>
                      <div className={style.option_view}>
                        {!isDrawingsExporting ? <input value={updatedValues?.metaData?.[`hardware_details_${i}`] || e?.[`hardware_details_${i}`] || ''} onChange={(v) => updateItems({ id: `hardware_details_${i}`, value: v.target.value })} /> : <span>{updatedValues?.metaData?.[`hardware_details_${i}`] || e?.[`hardware_details_${i}`] || '-'}</span>}
                      </div>
                    </p>
                    <p>
                      <div className={style.option_view}>
                        {!isDrawingsExporting ? <input value={updatedValues?.metaData?.[`final_details_${i}`] || e?.[`final_details_${i}`] || ''} onChange={(v) => updateItems({ id: `final_details_${i}`, value: v.target.value })} /> : <span>{updatedValues?.metaData?.[`final_details_${i}`] || e?.[`final_details_${i}`] || '-'}</span>}
                      </div>
                    </p>
                  </>
                ))
              }
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default CurtainsAumbre;